




















































import Vue from "vue";

import Slider from "@/components/common/Slider/index.vue";
import BaseModal from "@/components/organisms/Modal/BaseModal/BaseModal.vue";
import { DealerForm } from "@/components/forms";
import axios from "@/services/api/utils/interceptors";

import { Advantages } from "./blocks/Advantages";
import { Banner } from "./blocks/Banner";
import { Banners } from "./blocks/Banners";
import { CatalogLinks } from "./blocks/CatalogLinks";
import { CatalogSlider } from "./blocks/CatalogSlider";
import { Map } from "./blocks/Map";
import { Reviews } from "./blocks/Reviews";
import { SliderIcon } from "./blocks/SliderIcon";
import { indexModule } from "@/plugins/store-accessors";

export default Vue.extend({
  name: "Index",
  components: {
    "main-slider": Slider,
    "company-map": Map,
    CatalogLinks,
    SliderIcon,
    Banner,
    Advantages,
    Reviews,
    Banners,
    CatalogSlider,
    BaseModal,
    DealerForm,
  },
  data() {
    return {
      showPartnerModal: false,
    };
  },
  computed: {
    getData() {
      return indexModule.getData;
    },
    getMeta() {
      return indexModule.getMeta;
    },
  },
  async mounted() {
    document.title = this.getMeta.title || "";
  },
  methods: {
    submitAction(data: any) {
      return axios({
        method: "POST",
        url: "/api/partner",
        data,
      });
    },
    requestData() {
      return indexModule.requestData();
    },
    openModal() {
      this.showPartnerModal = true;
    },
  },
});
